
export const CUSTOMER_UDFS_LOADING = 'REDUX_SAGA_CUSTOMER_UDFS_LOADING';
export const CUSTOMER_UDFS_SUCCESS = 'REDUX_SAGA_CUSTOMER_UDFS_SUCCESS';
export const CUSTOMER_UDFS_ERROR = 'REDUX_SAGA_CUSTOMER_UDFS_ERROR';
export const RESET_CUSTOMER_UDFS = 'REDUX_SAGA_RESET_CUSTOMER_UDFS';

export const actionGetCustomerUdfs = (dispatch, customerIdList) => {
    dispatch({ type: CUSTOMER_UDFS_LOADING, customerIdList: customerIdList });
};

export const actionResetCustomerUdfs = (dispatch) => {
    dispatch({ type: RESET_CUSTOMER_UDFS })
};
